<template>
  <Loading v-if="loading || (!template && loadingInitial)" />
  <div v-else-if="template">
    <div class="flex justify-between mb-4">
      <p>
        <span>Click <vs-button size="small" @click.stop="manageNotificationRules" class="px-2 py-1">here</vs-button> to manage notification rules for EOD reports.</span>
      </p>
    </div>

    <vs-tabs position="left" class="tabs-shadow-none mt-2">
      <vs-tab icon-pack="feather" icon="icon-info" label="General info">
        <div class="eod-view-tab">
          <eod-template-general
            :template="template"
            :versions="versions"
            :isEditable="isEditable"
            @save="save"
            @publish="publish"
            @new-version="createNewVersion"
            @select-version="loadVersion"
          />
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-activity" label="Questions">
        <div class="eod-view-tab">
          <eod-template-questions
            :template="template"
            :isEditable="isEditable"
            :countryName="activeCountry ? activeCountry.name : null"
            @save="save"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
  <vx-card v-else title="No EOD template exists for this country yet">
    <vs-input class="w-full mb-4" label="Template Title" v-model="newTitle" placeholder="End of Day Report" />
    <vs-button @click="createTemplate">Create Template</vs-button>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import EodTemplateGeneral from "./EodTemplateGeneral.vue";
import EodTemplateQuestions from "./EodTemplateQuestions.vue";

export default {
  components: {
    EodTemplateGeneral,
    EodTemplateQuestions,
  },
  data() {
    return {
      loadingInitial: true,
      newTitle: "End of Day Report",
    };
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry",
    }),
    template() {
      return this.$store.getters["eodTemplates/template"];
    },
    versions() {
      return this.$store.getters["eodTemplates/versions"];
    },
    isEditable() {
      return this.template && !this.template.isPublished;
    },
    loading() {
      return this.loadingInitial;
    },
  },
  watch: {
    activeCountry() {
      this.loadForCountry();
    },
  },
  methods: {
    manageNotificationRules() {
      this.$router
        .push({ name: "manage-eod-notification-rules" })
        .catch(function () {});
    },

    async loadForCountry() {
      this.loadingInitial = true;
      try {
        await this.$store.dispatch("eodTemplates/getLatest", this.activeCountry.id);
        if (this.template) {
          await this.$store.dispatch("eodTemplates/getVersions", this.activeCountry.id);
        }
      } catch (e) {
        this.$store.commit("eodTemplates/SET_TEMPLATE", null);
      }
      this.loadingInitial = false;
    },

    async save() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("eodTemplates/saveTemplate");
        this.$vs.notify({ title: "Saved", text: "EOD template saved", color: "success" });
      } catch (e) {
        this.$vs.notify({ title: "Error", text: e.message, color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async publish() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("eodTemplates/publishTemplate");
        await this.loadForCountry();
        this.$vs.notify({ title: "Published", text: "EOD template published", color: "success" });
      } catch (e) {
        this.$vs.notify({ title: "Error", text: e.message, color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async createNewVersion() {
      try {
        this.$vs.loading();
        var newId = await this.$store.dispatch("eodTemplates/createNewVersion", this.activeCountry.id);
        await this.$store.dispatch("eodTemplates/getTemplate", newId);
        await this.$store.dispatch("eodTemplates/getVersions", this.activeCountry.id);
        this.$vs.notify({ title: "New Version", text: "New version created", color: "success" });
      } catch (e) {
        this.$vs.notify({ title: "Error", text: e.message, color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async loadVersion(templateId) {
      try {
        this.$vs.loading();
        await this.$store.dispatch("eodTemplates/getTemplate", templateId);
      } catch (e) {
        this.$vs.notify({ title: "Error", text: e.message, color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async createTemplate() {
      try {
        this.$vs.loading();
        var newId = await this.$store.dispatch("eodTemplates/createTemplate", {
          title: this.newTitle,
          country: this.activeCountry.id,
        });
        await this.$store.dispatch("eodTemplates/getTemplate", newId);
        await this.$store.dispatch("eodTemplates/getVersions", this.activeCountry.id);
      } catch (e) {
        this.$vs.notify({ title: "Error", text: e.message, color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.loadForCountry();
  },
};
</script>

<style lang="scss">
.eod-view-tab {
  margin-left: 12px;
}
</style>
